// import React, { useContext, useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Stack,
//   useTheme,
// } from "@mui/material";

// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";

// function SupportList() {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { spacing } = useTheme();

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 15;

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= API CALL ================= */

//   const fetchSupportList = async () => {
//     setLoading(true);
//     setLogData([]);

//     try {
//       const queryParams = new URLSearchParams({
//         STATUS: "A",
//       }).toString();

//       const bodyParams = new URLSearchParams({
//         USER_ID: localStorage.getItem("LoginID") || "",
//         WEB_KEY: "WEBXYZ",
//       }).toString();

//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?${queryParams}`;

//       console.log("API URL 👉", apiUrl);
//       console.log("BODY 👉", bodyParams);

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyParams,
//       });

//       const data = await response.json();
//       console.log("API RESPONSE 👉", data);

//       if (data?.COMP_LIST && Array.isArray(data.COMP_LIST)) {
//         setLogData(data.COMP_LIST);
//         setCurrentPage(1);
//       } else {
//         setLogData([]);
//       }
//     } catch (error) {
//       console.error("Fetch Error ❌", error);
//       setLogData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= AUTO LOAD ================= */
//   useEffect(() => {
//     fetchSupportList();
//   }, []);

//   /* ================= DYNAMIC HEADERS ================= */
//   const tableHeaders =
//     logData.length > 0 ? Object.keys(logData[0]) : [];

//   /* ================= RENDER ================= */

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Stack mt={1}>
//           <Card sx={{ p: spacing(1) }}>

//             {/* HEADER */}
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginBottom: "10px",
//               }}
//             >
//               <div style={{ fontSize: "14px" }}>
//                 <b>Support Ticket List</b>
//               </div>

//               <button
//                 className="button-style"
//                 onClick={fetchSupportList}
//               >
//                 Refresh
//               </button>
//             </div>

//             {/* TABLE */}
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead
//                   className="text-center"
//                   style={{ backgroundColor: "#fdf8e4" }}
//                 >
//                   <tr>
//                     {tableHeaders.map((h, i) => (
//                       <th key={i} style={{ color: PrimaryColor }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td
//                         colSpan={tableHeaders.length}
//                         className="text-center"
//                       >
//                         Loading...
//                       </td>
//                     </tr>
//                   ) : currentData.length > 0 ? (
//                     currentData.map((row, i) => (
//                       <tr key={i}>
//                         {tableHeaders.map((key, idx) => (
//                           <td key={idx} className="text-center">
//                             {row[key] ?? "-"}
//                           </td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={tableHeaders.length}
//                         className="text-center"
//                       >
//                         No support tickets found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//           </Card>
//         </Stack>
//       </Grid>
//     </Grid>
//   );
// }

// export default SupportList;


// 2.

// import React, { useContext, useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Stack,
//   useTheme,
//   Tabs,
//   Tab,
// } from "@mui/material";

// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";

// function SupportList() {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { spacing } = useTheme();

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* 🔥 STATUS TAB */
//   const [status, setStatus] = useState("P"); // default Pending

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 15;

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= API CALL ================= */

//   const fetchSupportList = async (selectedStatus = status) => {
//     setLoading(true);
//     setLogData([]);

//     try {
//       const queryParams = new URLSearchParams({
//         STATUS: selectedStatus,
//       }).toString();

//       const bodyParams = new URLSearchParams({
//         USER_ID: localStorage.getItem("LoginID") || "",
//         WEB_KEY: "WEBXYZ",
//         LOGIN_TYPE:"SOLAR",
//         LOGIN_ID2:localStorage.getItem("LoginID") || ""

//       }).toString();

//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?${queryParams}`;

//       console.log("API URL 👉", apiUrl);
//       console.log("BODY 👉", bodyParams);

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyParams,
//       });

//       const data = await response.json();
//       console.log("API RESPONSE 👉", data);

//       if (data?.COMP_LIST && Array.isArray(data.LIST)) {
//         setLogData(data.LIST);
//         setCurrentPage(1);
//       } else {
//         setLogData([]);
//       }
//     } catch (error) {
//       console.error("Fetch Error ❌", error);
//       setLogData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= AUTO LOAD ON STATUS CHANGE ================= */
//   useEffect(() => {
//     fetchSupportList(status);
//   }, [status]);

//   /* ================= TABLE HEADERS ================= */
//   const tableHeaders =
//     logData.length > 0 ? Object.keys(logData[0]) : [];

//   /* ================= RENDER ================= */

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Stack mt={1}>
//           <Card sx={{ p: spacing(1) }}>

//             {/* HEADER */}
//             {/* <div style={{ fontSize: "14px", marginBottom: "8px" }}>
//               <b>Support Ticket List</b>
//             </div> */}

//             {/* 🔥 STATUS TABS */}
//             <Tabs
//               value={status}
//               onChange={(e, newValue) => setStatus(newValue)}
//               textColor="primary"
//               indicatorColor="primary"
//               sx={{ mb: 1 }}
//             >
//               <Tab value="P" label="Pending" />
//               <Tab value="A" label="All" />
//               <Tab value="U" label="Under Process" />
//               <Tab value="C" label="Closed" />
//             </Tabs>

//             {/* TABLE */}
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead
//                   className="text-center"
//                   style={{ backgroundColor: "#fdf8e4" }}
//                 >
//                   <tr>
//                     {tableHeaders.map((h, i) => (
//                       <th key={i} style={{ color: PrimaryColor }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         Loading...
//                       </td>
//                     </tr>
//                   ) : currentData.length > 0 ? (
//                     currentData.map((row, i) => (
//                       <tr key={i}>
//                         {tableHeaders.map((key, idx) => (
//                           <td key={idx} className="text-center">
//                             {row[key] ?? "-"}
//                           </td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         No tickets found for selected status
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//           </Card>
//         </Stack>
//       </Grid>
//     </Grid>
//   );
// }

// export default SupportList;

// 3.

// import React, { useContext, useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Stack,
//   useTheme,
//   Tabs,
//   Tab,
// } from "@mui/material";

// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";

// function SupportList() {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { spacing } = useTheme();

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* 🔥 STATUS TAB (backend compatible) */
//   const [status, setStatus] = useState("PENDING");

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 15;

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= API CALL ================= */
//   const fetchSupportList = async (selectedStatus = status) => {
//     setLoading(true);
//     setLogData([]);

//     try {
//       const queryParams = new URLSearchParams({
//         STATUS: selectedStatus,
//       }).toString();

//       const bodyParams = new URLSearchParams({
//         USER_ID: localStorage.getItem("LoginID") || "",
//         WEB_KEY: "WEBXYZ",
//         LOGIN_TYPE: "SOLAR",
//         LOGIN_ID2: localStorage.getItem("LoginID") || "",
//       }).toString();

//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?${queryParams}`;

//       console.log("API URL 👉", apiUrl);
//       console.log("BODY 👉", bodyParams);

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyParams,
//       });

//       const data = await response.json();
//       console.log("API RESPONSE 👉", data);

//       /* ✅ FIXED KEY */
//       if (data?.LIST && Array.isArray(data.LIST)) {
//         setLogData(data.LIST);
//         setCurrentPage(1);
//       } else {
//         setLogData([]);
//       }
//     } catch (error) {
//       console.error("Fetch Error ❌", error);
//       setLogData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= AUTO LOAD ================= */
//   useEffect(() => {
//     fetchSupportList(status);
//   }, [status]);

//   /* ================= TABLE HEADERS ================= */
//   const tableHeaders =
//     logData.length > 0 ? Object.keys(logData[0]) : [];

//   /* ================= RENDER ================= */
//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Stack mt={1}>
//           <Card sx={{ p: spacing(1) }}>

//             {/* 🔥 STATUS TABS */}
//             <Tabs
//               value={status}
//               onChange={(e, v) => setStatus(v)}
//               textColor="primary"
//               indicatorColor="primary"
//               sx={{ mb: 1 }}
//             >
//               <Tab value="P" label="Pending" />
//               <Tab value="A" label="All" />
//               <Tab value="U" label="Under Process" />
//               <Tab value="C" label="Closed" />
//             </Tabs>

//             {/* TABLE */}
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead
//                   className="text-center"
//                   style={{ backgroundColor: "#fdf8e4" }}
//                 >
//                   <tr>
//                     {tableHeaders.map((h, i) => (
//                       <th key={i} style={{ color: PrimaryColor }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         Loading...
//                       </td>
//                     </tr>
//                   ) : currentData.length > 0 ? (
//                     currentData.map((row, i) => (
//                       <tr key={i}>
//                         {tableHeaders.map((key, idx) => (
//                           <td key={idx} className="text-center">
//                             {row[key] ?? "-"}
//                           </td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         No tickets found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//           </Card>
//         </Stack>
//       </Grid>
//     </Grid>
//   );
// }

// export default SupportList;

// 4.

// import React, { useContext, useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Stack,
//   Tabs,
//   Tab,
// } from "@mui/material";

// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";

// function SupportList() {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [logData, setLogData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* STATUS TAB */
//   const [status, setStatus] = useState("P");

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 8;

//   const totalPages = Math.ceil(logData.length / itemsPerPage);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= API CALL ================= */
//   const fetchSupportList = async (selectedStatus = status) => {
//     setLoading(true);
//     setLogData([]);

//     try {
//       const queryParams = new URLSearchParams({
//         STATUS: selectedStatus,
//       }).toString();

//       const bodyParams = new URLSearchParams({
//         USER_ID: localStorage.getItem("LoginID") || "",
//         WEB_KEY: "WEBXYZ",
//         LOGIN_TYPE: "SOLAR",
//         LOGIN_ID2: localStorage.getItem("LoginID") || "",
//       }).toString();

//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?${queryParams}`;

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyParams,
//       });

//       const data = await response.json();

//       if (Array.isArray(data?.LIST)) {
//         setLogData(data.LIST);
//         setCurrentPage(1); // reset page on tab change
//       } else {
//         setLogData([]);
//       }
//     } catch (error) {
//       console.error("Fetch Error ❌", error);
//       setLogData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* AUTO LOAD */
//   useEffect(() => {
//     fetchSupportList(status);
//   }, [status]);

//   /* TABLE HEADERS */
//   const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Stack>
//           <Card sx={{ p: 1 }}>
//             {/* STATUS TABS */}
//             <Tabs
//               value={status}
//               onChange={(e, v) => setStatus(v)}
//               sx={{ mb: 1 }}
//             >
//               <Tab value="P" label="Pending" />
//               <Tab value="A" label="All" />
//               <Tab value="U" label="Under Process" />
//               <Tab value="C" label="Closed" />
//             </Tabs>

//             {/* TABLE */}
//             <div className="table-responsive">
//               <table className="table table-bordered table-hover">
//                 <thead
//                   className="text-center"
//                   style={{ backgroundColor: "#fdf8e4" }}
//                 >
//                   <tr>
//                     {tableHeaders.map((h, i) => (
//                       <th key={i} style={{ color: PrimaryColor }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         Loading...
//                       </td>
//                     </tr>
//                   ) : currentData.length > 0 ? (
//                     currentData.map((row, i) => (
//                       <tr key={i}>
//                         {tableHeaders.map((key, idx) => (
//                           <td key={idx} className="text-center">
//                             {row[key] ?? "-"}
//                           </td>
//                         ))}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className="text-center">
//                         No tickets found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* ================= PAGINATION ================= */}
//             {totalPages > 1 && (
//               <Stack
//                 direction="row"
//                 justifyContent="center"
//                 alignItems="center"
//                 spacing={0.5}
//                 mt={1}
//               >
//                 <button
//                   className="btn btn-outline-secondary btn-sm"
//                   disabled={currentPage === 1}
//                   onClick={() => setCurrentPage((p) => p - 1)}
//                   style={{ padding: "2px 8px", fontSize: "12px" }}
//                 >
//                   Prev
//                 </button>

//                 {[...Array(totalPages)].map((_, i) => (
//                   <button
//                     key={i}
//                     onClick={() => setCurrentPage(i + 1)}
//                     className={`btn btn-sm ${currentPage === i + 1
//                         ? "btn-primary"
//                         : "btn-outline-secondary"
//                       }`}
//                     style={{
//                       padding: "2px 8px",
//                       fontSize: "12px",
//                       backgroundColor:
//                         currentPage === i + 1 ? PrimaryColor : "",
//                       borderColor:
//                         currentPage === i + 1 ? PrimaryColor : "",
//                     }}
//                   >
//                     {i + 1}
//                   </button>
//                 ))}

//                 <button
//                   className="btn btn-outline-secondary btn-sm"
//                   disabled={currentPage === totalPages}
//                   onClick={() => setCurrentPage((p) => p + 1)}
//                   style={{ padding: "2px 8px", fontSize: "12px" }}
//                 >
//                   Next
//                 </button>
//               </Stack>
//             )}
//           </Card>
//         </Stack>
//       </Grid>
//     </Grid>
//   );
// }

// export default SupportList;


// 5.

// import React, { useContext, useEffect, useState } from "react";
// import {
//   Card,
//   Grid,
//   Stack,
//   Tabs,
//   Tab,
//   TextField,
//   Button,
//   Box,
// } from "@mui/material";

// import { AppThemeContext } from "../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../api/AxiosApi";

// function SupportList() {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [logData, setLogData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   /* STATUS TAB */
//   const [status, setStatus] = useState("P");

//   /* SEARCH */
//   const [searchText, setSearchText] = useState("");

//   /* TAB COUNTS */
//   const [counts, setCounts] = useState({ P: 0, A: 0, U: 0, C: 0 });

//   /* ================= PAGINATION ================= */
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 8;

//   const dataToShow = searchText ? filteredData : logData;

//   const totalPages = Math.ceil(dataToShow.length / itemsPerPage);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = dataToShow.slice(indexOfFirstItem, indexOfLastItem);

//   /* ================= COMMON BODY ================= */
//   const getBodyParams = () =>
//     new URLSearchParams({
//       USER_ID: localStorage.getItem("LoginID") || "",
//       WEB_KEY: "WEBXYZ",
//       LOGIN_TYPE: "SOLAR",
//       LOGIN_ID2: localStorage.getItem("LoginID") || "",
//     }).toString();

//   /* ================= LIST API ================= */
//   const fetchSupportList = async (selectedStatus = status) => {
//     setLoading(true);
//     setLogData([]);
//     setFilteredData([]);
//     setSearchText("");

//     try {
//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?STATUS=${selectedStatus}`;

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: getBodyParams(),
//       });

//       const data = await response.json();
//       setLogData(Array.isArray(data?.LIST) ? data.LIST : []);
//       setCurrentPage(1);
//     } catch (err) {
//       console.error("Fetch Error ❌", err);
//       setLogData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= COUNT API ================= */
//   const fetchCountByStatus = async (statusCode) => {
//     try {
//       const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?STATUS=${statusCode}`;

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: getBodyParams(),
//       });

//       const data = await response.json();
//       return Array.isArray(data?.LIST) ? data.LIST.length : 0;
//     } catch {
//       return 0;
//     }
//   };

//   const fetchAllCounts = async () => {
//     const [p, a, u, c] = await Promise.all([
//       fetchCountByStatus("P"),
//       fetchCountByStatus("A"),
//       fetchCountByStatus("U"),
//       fetchCountByStatus("C"),
//     ]);

//     setCounts({ P: p, A: a, U: u, C: c });
//   };

//   /* ================= SEARCH ================= */
//   const handleSearch = () => {
//     if (!searchText.trim()) {
//       setFilteredData([]);
//       return;
//     }

//     const filtered = logData.filter((row) =>
//       Object.values(row).some((val) =>
//         String(val).toLowerCase().includes(searchText.toLowerCase())
//       )
//     );

//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   /* AUTO LOAD */
//   useEffect(() => {
//     fetchSupportList(status);
//     fetchAllCounts();
//   }, [status]);

//   /* TABLE HEADERS */
//   const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//   return (
//     <Grid container>
//       <Grid item xs={12}>
//         <Card sx={{ p: 1 }}>
//           {/* TABS + SEARCH */}
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//             mb={1}
//           >
//             <Tabs value={status} onChange={(e, v) => setStatus(v)}>
//               <Tab value="P" label={`Pending (${counts.P})`} />
//               <Tab value="A" label={`All (${counts.A})`} />
//               <Tab value="U" label={`Under Process (${counts.U})`} />
//               <Tab value="C" label={`Closed (${counts.C})`} />
//             </Tabs>

//             <Stack direction="row" spacing={1}>
//               <TextField
//                 size="small"
//                 placeholder="Search"
//                 value={searchText}
//                 onChange={(e) => setSearchText(e.target.value)}
//               />
//               <Button
//                 // size="small"
//                 variant="contained"
//                 onClick={handleSearch}
//                 sx={{ backgroundColor: PrimaryColor }}
//               >
//                 Search
//               </Button>
//             </Stack>
//           </Box>

//           {/* TABLE */}
//           <div className="table-responsive">
//             <table className="table table-bordered table-hover">
//               <thead
//                 className="text-center"
//                 style={{ backgroundColor: "#fdf8e4" }}
//               >
//                 <tr>
//                   {tableHeaders.map((h, i) => (
//                     <th key={i} style={{ color: PrimaryColor }}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={tableHeaders.length} className="text-center">
//                       Loading...
//                     </td>
//                   </tr>
//                 ) : currentData.length > 0 ? (
//                   currentData.map((row, i) => (
//                     <tr key={i}>
//                       {tableHeaders.map((key, idx) => (
//                         <td key={idx} className="text-center">
//                           {row[key] ?? "-"}
//                         </td>
//                       ))}
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={tableHeaders.length} className="text-center">
//                       No tickets found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* PAGINATION */}
//           {totalPages > 1 && (
//             <Stack direction="row" justifyContent="center" spacing={0.5} mt={1}>
//               <button
//                 className="btn btn-outline-secondary btn-sm"
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((p) => p - 1)}
//               >
//                 Prev
//               </button>

//               {[...Array(totalPages)].map((_, i) => (
//                 <button
//                   key={i}
//                   onClick={() => setCurrentPage(i + 1)}
//                   className={`btn btn-sm ${
//                     currentPage === i + 1
//                       ? "btn-primary"
//                       : "btn-outline-secondary"
//                   }`}
//                   style={{
//                     backgroundColor:
//                       currentPage === i + 1 ? PrimaryColor : "",
//                     borderColor:
//                       currentPage === i + 1 ? PrimaryColor : "",
//                   }}
//                 >
//                   {i + 1}
//                 </button>
//               ))}

//               <button
//                 className="btn btn-outline-secondary btn-sm"
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((p) => p + 1)}
//               >
//                 Next
//               </button>
//             </Stack>
//           )}
//         </Card>
//       </Grid>
//     </Grid>
//   );
// }

// export default SupportList;


import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  Grid,
  Stack,
  Tabs,
  Tab,
  TextField,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../api/AxiosApi";

function SupportList() {
  const { PrimaryColor } = useContext(AppThemeContext);

  const [logData, setLogData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState("P");
  const [searchText, setSearchText] = useState("");
  const [counts, setCounts] = useState({ P: 0, A: 0, U: 0, C: 0 });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const dataToShow = searchText ? filteredData : logData;
  const totalPages = Math.ceil(dataToShow.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = dataToShow.slice(indexOfFirstItem, indexOfLastItem);

  /* 🎨 STATUS COLOR */
  const getStatusStyle = (status) => {
    switch (status) {
      case "PENDING":
        return { color: "#dc2626", fontWeight: "bold" };
      case "UNDER PROCESS":
        return { color: "#f97316", fontWeight: "bold" };
      case "CLOSED":
        return { color: "#16a34a", fontWeight: "bold" };
      default:
        return {};
    }
  };


  /* ================= COMMON BODY ================= */
  const getBodyParams = () =>
    new URLSearchParams({
      USER_ID: localStorage.getItem("LoginID") || "",
      WEB_KEY: "WEBXYZ",
      LOGIN_TYPE: "SOLAR",
      LOGIN_ID2: localStorage.getItem("LoginID") || "",
    }).toString();

  /* ================= LIST API ================= */
  const fetchSupportList = async (selectedStatus = status) => {
    setLoading(true);
    setLogData([]);
    setFilteredData([]);
    setSearchText("");

    try {
      const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?STATUS=${selectedStatus}`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: getBodyParams(),
      });

      const data = await response.json();
      setLogData(Array.isArray(data?.LIST) ? data.LIST : []);
      setCurrentPage(1);
    } catch (err) {
      console.error("Fetch Error ❌", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= COUNT API ================= */
  const fetchCountByStatus = async (statusCode) => {
    try {
      const apiUrl = `${BaseUrl}Invent_03_UP/Support_List?STATUS=${statusCode}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: getBodyParams(),
      });

      const data = await response.json();
      return Array.isArray(data?.LIST) ? data.LIST.length : 0;
    } catch {
      return 0;
    }
  };

  const fetchAllCounts = async () => {
    const [p, a, u, c] = await Promise.all([
      fetchCountByStatus("P"),
      fetchCountByStatus("A"),
      fetchCountByStatus("U"),
      fetchCountByStatus("C"),
    ]);
    setCounts({ P: p, A: a, U: u, C: c });
  };

  /* ================= SEARCH AUTO ================= */
  useEffect(() => {
    if (!searchText.trim()) {
      setFilteredData([]);
      setCurrentPage(1);
      return;
    }

    const filtered = logData.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchText, logData]);

  useEffect(() => {
    fetchSupportList(status);
    fetchAllCounts();
  }, [status]);

  const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card sx={{ p: 1 }}>
          {/* TABS + SEARCH */}
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Tabs value={status} onChange={(e, v) => setStatus(v)}>
              <Tab value="P" label={`Pending (${counts.P})`} />
              <Tab value="A" label={`All (${counts.A})`} />
              <Tab value="U" label={`Under Process (${counts.U})`} />
              <Tab value="C" label={`Closed (${counts.C})`} />
            </Tabs>

            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                size="small"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              <Button
                variant="contained"
                sx={{ backgroundColor: PrimaryColor }}
                onClick={() => fetchSupportList(status)}
              >
                Search
              </Button>

              {/* <IconButton
                onClick={() => fetchSupportList(status)}
                sx={{ backgroundColor: "#e0f2fe" }}
              >
                <RefreshIcon sx={{ color: PrimaryColor }} />
              </IconButton> */}

              <IconButton
                size="small"
                onClick={() => fetchSupportList(status)}
                sx={{ backgroundColor: "#e0f2fe" }}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>



            </Stack>
          </Box>

          {/* TABLE */}
          <div className="table-responsive">
            <table className="table table-bordered table-hover">
              <thead style={{ backgroundColor: "#fdf8e4" }}>
                <tr>
                  {tableHeaders.map((h, i) => (
                    <th key={i} style={{ color: PrimaryColor }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={tableHeaders.length} className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : currentData.length ? (
                  currentData.map((row, i) => (
                    <tr key={i}>
                      {tableHeaders.map((key, idx) => (
                        <td key={idx} className="text-center">
                          {key.toLowerCase().includes("status") ? (
                            <span
                              style={{
                                padding: "4px 10px",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: 600,
                                ...getStatusStyle(row[key]),
                              }}
                            >
                              {row[key]}
                            </span>
                          ) : (
                            row[key] ?? "-"
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={tableHeaders.length} className="text-center">
                      No tickets found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}

export default SupportList;


